<template>
  <div class="weijiekongdan">
    <el-scrollbar id="menuWarpper"
                  style="height: calc(100%)">
      <el-main>
        <div class="header"
             ref="header">
          <div class="headerTop">
            <div class="header-con">
              <div class="header-con-form">
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">客户名称:</div>
                  <el-input v-model="chanpinxian"
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1, dqcxzt)">
                  </el-input>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">工单编号:</div>
                  <el-input v-model="gongdanCode"
                            clearable
                            class="form-item-inputcpx"
                            placeholder="请输入"
                            @keyup.enter.native="ChaXun(1, dqcxzt)">
                  </el-input>
                </div>

                <div class="header-con-form-item">
                  <div class="sousuomingcheng">产品线:</div>
                  <el-select v-model="productLine"
                             placeholder="请选择"
                             clearable
                             multiple
                             size="small"
                             class="form-item-inputcpx"
                             @change="dianjichanpinxian"
                             popper-class="eloption">
                    <!-- :popper-append-to-body="false" -->
                    <el-option v-for="item in staff"
                               :key="item.Code"
                               :label="item.Name"
                               :value="item.Code" />
                  </el-select>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">起始日期:</div>
                  <el-date-picker v-model="kaishishijian"
                                  style="width: 200px"
                                  :clearable="false"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </div>
                <div class="header-con-form-item">
                  <div class="sousuomingcheng">终止日期:</div>
                  <el-date-picker v-model="jieshushijian"
                                  style="width: 200px"
                                  :clearable="false"
                                  type="date"
                                  range-separator="至"
                                  value-format="yyyy-MM-dd"
                                  start-placeholder="开始日期"
                                  end-placeholder="结束日期">
                  </el-date-picker>
                </div>

                <el-button type="success"
                           class="anniuclass"
                           @click="ChaXun(1, 'rq')"
                           :disabled="isChaXun">根据日期查询</el-button>
                <el-button type="danger"
                           class="anniuclass"
                           @click="ChaXun(1, 'qb')"
                           :disabled="isChaXun">查看全部工单</el-button>
                <el-button type="primary"
                           class="anniuclass"
                           @click="xinjianGongDan()">新建工单</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="maina"
             v-bind:style="{ height: EchartsHeight }">
          <el-table :data="tableData"
                    height="100%"
                    ref="tableData"
                    highlight-current-row
                    resizable
                    stripe
                    border
                    @row-dblclick="shuangjiChaKan">
            <el-table-column align="center"
                             type="index"
                             label="序号"
                             width="50"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                <div style="background-color: crimson"
                     v-if="SCXZ == scope.$index + 1">
                  {{ scope.$index + 1 }}
                </div>
                <div v-else>{{ scope.$index + 1 }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="CODE"
                             label="工单号"
                             width="150"
                             show-overflow-tooltip>
            </el-table-column>

            <el-table-column align="left"
                             prop="CUSTOMER_NAME"
                             label="客户名称"
                             min-width="220px">
              <template slot-scope="scope">
                <div style="display: inline-block; vertical-align: bottom">
                  <img v-if="scope.row.SLEVEL == 'S'"
                       style="width: 20px; height: 20px"
                       src="../../assets/img/tupianS.png" />
                  <img v-if="scope.row.SLEVEL == 'A'"
                       style="width: 20px; height: 20px"
                       src="../../assets/img/tupianA.png" />
                  <img v-if="scope.row.SLEVEL == 'B'"
                       style="width: 20px; height: 20px"
                       src="../../assets/img/tupianB.png" />
                  <img v-if="scope.row.SLEVEL == 'C'"
                       style="width: 20px; height: 20px"
                       src="../../assets/img/tupianC.png" />
                  <img v-if="scope.row.SLEVEL == 'D'"
                       style="width: 20px; height: 20px"
                       src="../../assets/img/tupianD.png" />
                </div>

                <div style="display: inline-block; height: 28px">
                  {{ scope.row.CUSTOMER_NAME }}
                </div>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="CONTACTS"
                             label="客户联系人"
                             width="100"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="CONTACT_INFORMATION"
                             label="客户联系方式"
                             width="150"
                             show-overflow-tooltip>
            </el-table-column>

            <el-table-column align="center"
                             prop="DESCRIBE"
                             label="留言"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="PRODUCT_LINE1"
                             label="产品线"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="INFO_TYPE1"
                             label="类型"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             prop="SPONSOR"
                             label="发起人"
                             show-overflow-tooltip>
            </el-table-column>

        

            <el-table-column align="center"
                             prop="LAUNCH_TIME"
                             label="发起日期"
                             width="190"
                             show-overflow-tooltip>
              <template v-if="scope.row.LAUNCH_TIME != null"
                        slot-scope="scope">
                {{
                  scope.row.LAUNCH_TIME.toLocaleString()
                    .replace(/T/g, " ")
                    .replace(/\.[\d]{3}Z/, "")
                }}
              </template>
            </el-table-column>
            <el-table-column align="center"
                             prop="INFO_STATUS1"
                             label="状态"
                             show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center"
                             v-if="renyuan == 13"
                             label="操作"
                             fixed="right"
                             width="220px"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button type="primary"
                           @click="viewDoc(scope)">查看</el-button>
                <el-button type="success"
                           @click="jiedan(scope)">接单</el-button>
                <el-button v-if="renyuan == 13"
                           type="danger"
                           @click="paidan(scope)">派单</el-button>
              </template>
            </el-table-column>
            <el-table-column align="center"
                             v-else
                             label="操作"
                             fixed="right"
                             width="150px"
                             show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button type="primary"
                           @click="viewDoc(scope)">查看</el-button>
                <el-button type="success"
                           @click="jiedan(scope)">接单</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer"
             ref="footer">
          <pagination :allPage="allPage"
                      :pageSize="pageSize"
                      :currIndex="currPage"
                      @hanSiChange="hanSiChange"
                      @hanCurrChange="hanCurrChange"></pagination>
        </div>
      </el-main>
    </el-scrollbar>
    <!-- <el-dialog :visible.sync="jdxzyjwcsj" width="400px">
			<div class="containeraxjgd">
				<div class="tckmingcheng">
					选择预计完成日时间
				</div>
				<div class="tckmingchenga">
					<el-date-picker v-model="yujiwanchengshijian" type="datetime" placeholder="选择日期时间">
					</el-date-picker>
				</div>
				<div class="tijiaobtnxjgdza">
					<el-button class="tijiaobtnxjgda" @click="guanbijiedantk()">取消
					</el-button>
				</div>
				<div class="tijiaobtnxjgdza">
					<el-button class="tijiaobtnxjgdb" type="primary" @click="querenjiedan()" :disabled="isQueRenJieDan">
						确认接单
					</el-button>
				</div>
			</div>
		</el-dialog> -->
    <el-dialog :visible.sync="jdxzyjwcsj"
               width="600px">
      <!-- <div class="containeraxjgd"> -->
      <div class="headerzhuandanyuanyin">
        <el-form class="header-con-form"
                 :inline="true">
          <div style="width: 30%">选择预计完成日时间</div>
          <el-date-picker v-model="yujiwanchengshijian"
                          style="width: 60%"
                          type="datetime"
                          placeholder="选择日期时间">
          </el-date-picker>
        </el-form>
      </div>
      <div class="headerzhuandanyuanyin">
        <el-form class="header-con-form"
                 :inline="true">
          <div style="width: 30%">难易程度</div>
          <el-select v-model="strNycd"
                     style="width: 60%"
                     placeholder="请选择">
            <el-option v-for="item in optionsNY"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form>
      </div>
      <div class="tijiaobtnxjgdza">
        <el-button class="tijiaobtnxjgda"
                   @click="jdxzyjwcsj = false">取消
        </el-button>
      </div>
      <div class="tijiaobtnxjgdza">
        <el-button class="tijiaobtnxjgdb"
                   type="primary"
                   @click="querenjiedan()"
                   :disabled="isQueRenJieDan">
          确认接单
        </el-button>
      </div>
      <!-- </div> -->
    </el-dialog>
    <el-dialog title="选择客服"
               :visible.sync="formDialogkf"
               width="80%"
               height="80%">
      <div class="containera">
        <el-card class="headera">
          <div class="header-cona">
            <el-form class="header-con-form"
                     :inline="true"
                     @submit.native.prevent>
              <el-form-item class="header-con-form-item"
                            label="客服姓名:">
                <el-input v-model="form.xuanzekefu"
                          style="width: 200px"
                          placeholder="请输入"
                          ref="kefuchaxun"
                          @change="getKefumingdan(1)"
                          @keyup.enter.native="getKefumingdan(1)">
                </el-input>
              </el-form-item>
              <el-button type="primary"
                         @click="getKefumingdan(1)"
                         :disabled="isChaXunkfm">查询</el-button>
            </el-form>
          </div>
          <div></div>
        </el-card>
        <div class="main"
             v-bind:style="{ height: EchartsHeight }">
          <el-table :data="tableDatakf"
                    height="100%"
                    highlight-current-row
                    resizable
                    stripe
                    border
                    @row-dblclick="handledbClickkf">
            <el-table-column align="center"
                             type="index"
                             label="序号"
                             width="50">
            </el-table-column>
            <el-table-column align="center"
                             prop="NAME"
                             label="姓名">
            </el-table-column>
            <el-table-column align="center"
                             prop="JOB_NUMBER"
                             label="编号">
            </el-table-column>
            <el-table-column align="center"
                             prop="PRODUCT_LINE1"
                             label="产品线">
            </el-table-column>
            <el-table-column align="center"
                             prop="ROLE_NAME"
                             label="角色">
            </el-table-column>

            <el-table-column align="center"
                             label="操作"
                             fixed="right">
              <template slot-scope="scope">
                <el-button type="primary"
                           @click="viewDockf(scope)"
                           :disabled="isPaiDan">
                  选择</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="footer"
             ref="footer">
          <pagination :allPage="allPagekf"
                      :pageSize="pageSizekf"
                      :currIndex="currPagekf"
                      @hanSiChange="hanSiChangekf"
                      @hanCurrChange="hanCurrChangekf"></pagination>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "weijiekongdan",
  data () {
    return {
      SCXZ: "",
      Nowscroll: 0,
      gongdanCode: "",
      isQueRenJieDan: false,
      isPaiDan: false,
      isChaXunkfm: false,
      isChaXun: true,
      count: 15,
      jixuqingqiu: false,
      dqcxzt: "qb",
      dangqiandanhao: "",
      jdxzyjwcsj: false,
      renyuan: JSON.parse(localStorage.getItem("userInfo")).ROLE,
      EchartsHeight: document.body.clientHeight - 200 + "px",
      WenTileixingList: [],
      staffcopy: [],
      staff: [], //产品线
      staffz: [], //产品线
      chanpinxian: "", //客户名称
      productLine: "", //产品线
      kaishishijian: "",
      jieshushijian: "",
      loading: false,
      formDialogkf: false,
      currPage: 1,
      pageSize: 50,
      allPage: 0,
      currPagekf: 1,
      pageSizekf: 50,
      allPagekf: 0,
      tableDatakf: [],
      tableData: [],
      yujiwanchengshijian: "",
      optionsNY: [
        {
          value: 1,
          label: "一级",
        },
        {
          value: 2,
          label: "二级",
        },
        {
          value: 3,
          label: "三级",
        },
      ],
      strNycd: 1,
      form: {
        xuanzekefu: "",
      },
    };
  },

  mounted () {
    this.SCXZ = "";
    const that = this;
    // window.onresize = () => {
    // 	// return (() => {
    // 	window.screenHeight = document.body.clientHeight
    // 	that.EchartsHeight = (window.screenHeight - 200) + 'px'
    // 	that.EchartsHeightxjgd = (window.screenHeight - 200) + 'px'
    // 	// })()
    // }
    window.onresize = () => {
      // return (() => {

      window.screenHeight = document.body.clientHeight;

      that.EchartsHeight =
        window.screenHeight -
        this.$refs.header.offsetHeight -
        this.$refs.footer.offsetHeight -
        70 +
        "px";
      that.EchartsHeightxjgd =
        window.screenHeight -
        this.$refs.header.offsetHeight -
        this.$refs.footer.offsetHeight -
        70 +
        "px";

      // })()
    };
    this.getPerson();
    this.getWenTileixing();

    this.addDate();

    this.currPage = 1;
    this.ChaXun(this.currPage, this.dqcxzt);
  },
  activated () {
    const that = this;
    window.onresize = () => {
      // return (() => {

      window.screenHeight = document.body.clientHeight;

      that.EchartsHeight =
        window.screenHeight -
        this.$refs.header.offsetHeight -
        this.$refs.footer.offsetHeight -
        70 +
        "px";
      that.EchartsHeightxjgd =
        window.screenHeight -
        this.$refs.header.offsetHeight -
        this.$refs.footer.offsetHeight -
        70 +
        "px";

      // })()
    };
    setTimeout(() => {
      this.$refs.tableData.bodyWrapper.scrollTop = this.Nowscroll;
    }, 13);
    this.getPerson();
    this.getWenTileixing();
    this.addDate();
    this.currPage = 1;
    this.ChaXun(this.currPage, this.dqcxzt);
  },
  beforeRouteEnter (to, form, next) {
    next((vm) => {
      vm.ChaXun(1, vm.dqcxzt);
    });
  },
  methods: {
    dianjichanpinxian () {
      this.staff = this.staffz;
      this.ChaXun(1);
    },
    //客服双击
    handledbClickkf (row) {
      if (row.ROLE_NAME == "客服") {
        this.$confirm(
          "确定将工单号" + this.dangqiandanhao + "派单给" + row.NAME + "么？",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            let data = {
              code: this.dangqiandanhao, //工单号
              job_number: row.JOB_NUMBER, //工号
            };
            this.$request({
              method: "post",
              url: "Info/Transfer",
              data: data,
            })
              .then((res) => {
                if (res.Code == "0" || res.Code == 0) {
                  this.$message({
                    type: "success",
                    message: "派单" + res.Msg + "!",
                  });
                  if (res.Msg == "成功") {
                    this.formDialogkf = false;
                    this.ChaXun(1, this.dqcxzt);
                  }
                }
              })
              .catch((err) => {
                if (err == "Error: Request failed with status code 401") {
                  this.$router.push({
                    path: "/login",
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消派单",
            });
          });
        // this.kefumingcheng = row.NAME;
        // this.kefubianhao = row.JOB_NUMBER;
        // this.formDialogkf = false;
        // if (this.kefumingcheng != "") {
        // 	this.form.xuanzekefu = this.kefumingcheng;
        // } else {
        // 	this.form.xuanzekefu = "";
        // }
      } else {
        this.$message({
          message: "仅可下发给客服！",
          type: "error",
        });
      }
    },
    /**查看分类下文档 */
    viewDockf (row) {
      this.$confirm(
        "确定将工单号" + this.dangqiandanhao + "派单给" + row.row.NAME + "么？",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          this.isPaiDan = true;
          let data = {
            code: this.dangqiandanhao, //工单号
            job_number: row.row.JOB_NUMBER, //工号
          };
          this.$request({
            method: "post",
            url: "Info/Transfer",
            data: data,
          })
            .then((res) => {
              this.isPaiDan = false;
              if (res.Code == "0" || res.Code == 0) {
                this.$message({
                  type: "success",
                  message: "派单" + res.Msg + "!",
                });
                if (res.Msg == "成功") {
                  this.formDialogkf = false;
                  this.ChaXun(1, this.dqcxzt);
                }
              }
            })
            .catch((err) => {
              this.isPaiDan = false;
              if (err == "Error: Request failed with status code 401") {
                this.$router.push({
                  path: "/login",
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消派单",
          });
        });
      // this.kefumingcheng = row.row.NAME;
      // this.kefubianhao = row.row.JOB_NUMBER;
      // this.formDialogkf = false;
      // if (this.kefumingcheng != "") {
      // 	this.form.xuanzekefu = this.kefumingcheng;
      // } else {
      // 	this.form.xuanzekefu = "";
      // }
    },

    guanbijiedantk () {
      this.jdxzyjwcsj = false;
    },
    //双击查看工单
    shuangjiChaKan (row) {
      this.SCXZ = row.$index + 1;

      let vmEl = this.$refs["tableData"].$el;
      const scrollParent = vmEl.querySelector(".el-table__body-wrapper");
      this.Nowscroll = scrollParent.scrollTop;
      console.log("this.Nowscroll", this.Nowscroll);
      if (this.renyuan == 11) {
        this.$router.push({
          path: "gongdanxiangqing",
          query: {
            zhuangtai: "N",
            qianyiyemingcheng: "未接工单",
            code: row.CODE,
            qianyiyemianglujing: "/home/weijiekongdan",
          },
        });
      } else {
        this.$router.push({
          path: "gongdanxiangqing",
          query: {
            zhuangtai: "N",
            qianyiyemingcheng: "未完成工单",
            code: row.CODE,
            qianyiyemianglujing: "/home/weijiekongdan",
          },
        });
      }
    },
    //客户双击
    handledbClick (row) {
      this.kehumingchengxjgd = row.BUSINESSNAME;
      this.kehubianhaoxjgd = row.BUSINESSCODE;
      this.formxjgd.name = row.CONTACT;
      this.formxjgd.dianhua = row.TELEPHONE;
      this.formxzkhlog = false;
      if (this.kehumingchengxjgd != "") {
        this.xuanzekehuxjgd = this.kehumingchengxjgd;
      } else {
        this.xuanzekehuxjgd = "";
      }
    },
    //查询
    ChaXun (index, zt) {
      this.dqcxzt = zt;
      this.currPage = index;
      this.loading = true;
      this.isChaXun = true;
      let url =
        "Info/GetInfoList?customname=" +
        encodeURIComponent(this.chanpinxian) +
        "&startDate=" +
        encodeURIComponent(this.kaishishijian + " 00:00:00") +
        "&endDate=" +
        encodeURIComponent(this.jieshushijian + " 23:59:59") +
        "&code=" +
        encodeURIComponent(this.gongdanCode) +
        "&pageIndex=" +
        encodeURIComponent(index) +
        "&pageSize=" +
        encodeURIComponent(this.pageSize) +
        "&productLine=" +
        encodeURIComponent(this.productLine);

      if (zt == "qb") {
        url =
          "Info/GetInfoList?customname=" +
          encodeURIComponent(this.chanpinxian) +
          "&startDate=''" +
          "&endDate=''" +
          "&code=" +
          encodeURIComponent(this.gongdanCode) +
          "&pageIndex=" +
          encodeURIComponent(index) +
          "&pageSize=" +
          encodeURIComponent(this.pageSize) +
          "&productLine=" +
          encodeURIComponent(this.productLine);
      }
      window.localStorage.setItem("wjstartDate", this.kaishishijian);
      window.localStorage.setItem("wjendDate", this.jieshushijian);
      this.$request({
        method: "GET",
        url: url,
      })
        .then((res) => {
          this.isChaXun = false;
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            this.tableData = res.Data;
          }
          if (this.tableData.length > 0) {
            for (var i in this.tableData) {
              if (this.tableData[i].INFO_STATUS == 0) {
                this.$set(this.tableData[i], "INFO_STATUS1", "已撤销");
              } else if (this.tableData[i].INFO_STATUS == 1) {
                this.$set(this.tableData[i], "INFO_STATUS1", "已发起");
              } else if (this.tableData[i].INFO_STATUS == 2) {
                this.$set(this.tableData[i], "INFO_STATUS1", "已接单");
              } else if (this.tableData[i].INFO_STATUS == 3) {
                this.$set(this.tableData[i], "INFO_STATUS1", "已处理");
              } else if (this.tableData[i].INFO_STATUS == 4) {
                this.$set(this.tableData[i], "INFO_STATUS1", "已驳回");
              } else if (this.tableData[i].INFO_STATUS == 5) {
                this.$set(this.tableData[i], "INFO_STATUS1", "已完成");
              }
              for (var j in this.staff) {
                if (this.tableData[i].PRODUCT_LINE == this.staff[j].Code) {
                  this.$set(
                    this.tableData[i],
                    "PRODUCT_LINE1",
                    this.staff[j].Name
                  );
                }
              }
              for (var z in this.WenTileixingList) {
                if (
                  this.tableData[i].INFO_TYPE == this.WenTileixingList[z].Code
                ) {
                  this.$set(
                    this.tableData[i],
                    "INFO_TYPE1",
                    this.WenTileixingList[z].Name
                  );
                }
              }
            }
          }
          if (this.$refs.header.offsetHeight == 0) {
            this.EchartsHeight = document.body.clientHeight - 230 + "px";
            this.EchartsHeightxjgd =
              window.screenHeight -
              this.$refs.header.offsetHeight -
              this.$refs.footer.offsetHeight -
              70 +
              "px";
          } else {
            this.EchartsHeight =
              document.body.clientHeight -
              this.$refs.header.offsetHeight -
              130 +
              "px";
            this.EchartsHeightxjgd =
              window.screenHeight -
              this.$refs.header.offsetHeight -
              this.$refs.footer.offsetHeight -
              70 +
              "px";
          }
          this.allPage = res.Total;
          console.log("this.Nowscroll", this.Nowscroll);
          setTimeout(() => {
            this.$refs.tableData.bodyWrapper.scrollTop = this.Nowscroll;
          }, 13);
        })
        .catch((err) => {
          this.isChaXun = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },

    /**获取类型*/
    getWenTileixing () {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetGdLx",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            this.WenTileixingList = res.Data;
          }
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    //新建工单
    xinjianGongDan () {
      this.$router.push({
        path: "xinjiangongdan",
      });
      // this.$router.push({
      // 	path: "xinjiangongdan",
      // 	qianyiyemingcheng: '未接工单',
      // });
      // this.formxjgdlog = true;
    },
    /**获取产品线 */
    getPerson () {
      this.loading = true;

      this.$request({
        method: "GET",
        url: "Dictionary/GetProducts",
      })
        .then((res) => {
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            var arr = [];
            if (this.renyuan == 12) {
              this.staff = res.Data;
              this.staffz = res.Data;
              this.staffcopy = this.staff;
            } else {
              var bdcpx = JSON.parse(
                localStorage.getItem("userInfo")
              ).PRODUCT_LINE.split(",");

              for (var i in res.Data) {
                for (var j in bdcpx) {
                  if (res.Data[i].Code == bdcpx[j]) {
                    arr.push(res.Data[i]);
                  }
                }
              }
              this.staff = arr;
              this.staffz = arr;
              this.staffcopy = this.staff;
            }
          }
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    jiedan (row) {
      this.dangqiandanhao = row.row.CODE;
      this.jdxzyjwcsj = true;
    },
    paidan (row) {
      this.dangqiandanhao = row.row.CODE;
      this.formDialogkf = true;
      this.getKefumingdan(1);
      this.$nextTick(() => {
        this.$refs.kefuchaxun.focus();
      });
    },
    /**获取客服名单 */
    getKefumingdan (index) {
      this.currPagekf = index;

      this.loading = true;
      this.isChaXunkfm = true;
      this.$request({
        method: "GET",
        url:
          "ACCOUNT/GetServiceAccountList?zh=" +
          encodeURIComponent(this.form.xuanzekefu) +
          "&status=-1&pageIndex=" +
          encodeURIComponent(index) +
          "&pageSize=" +
          encodeURIComponent(this.pageSizekf),
      })
        .then((res) => {
          this.isChaXunkfm = false;
          this.loading = false;
          if (res.Code == "0" || res.Code == 0) {
            this.tableDatakf = res.Data;
          }
          if (this.tableDatakf.length > 0) {
            for (var i in this.tableDatakf) {
              var bdcpx = this.tableDatakf[i].PRODUCT_LINE.split(",");
              var xin = [];
              for (var z in bdcpx) {
                for (var j in this.staff) {
                  if (bdcpx[z] == this.staff[j].Code) {
                    xin.push(this.staff[j].Name);
                    this.$set(
                      this.tableDatakf[i],
                      "PRODUCT_LINE1",
                      xin.join(",")
                    );
                  }
                }
              }
            }
          }
          this.allPagekf = res.Total;
        })
        .catch((err) => {
          this.isChaXunkfm = false;
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },
    querenjiedan () {
      if (this.dangqiandanhao == "" || this.dangqiandanhao == null) {
        this.$message({
          message: "请重新选择订单！",
          type: "error",
        });
      } else if (
        this.yujiwanchengshijian == "" ||
        this.yujiwanchengshijian == null
      ) {
        this.$message({
          message: "请选择时间！",
          type: "error",
        });
      } else {
        let data = {
          code: this.dangqiandanhao, //产品线
          time: this.yujiwanchengshijian, //时间
          level: this.strNycd, //难度
        };
        this.isQueRenJieDan = true;
        this.$request({
          method: "post",
          url: "Info/JieDan",
          data: data,
        })
          .then(() => {
            this.jixuqingqiu = true;
            this.jiedanzhuataicx();
            this.count = 10; //赋值3秒
            var times = setInterval(() => {
              this.count--; //递减
              if (this.count <= 0) {
                this.jixuqingqiu = false;
                this.isQueRenJieDan = false;
                clearInterval(times);
                console.log(this.jixuqingqiu);
              }
            }, 1000); //1000毫秒后执行

            // this.$message({
            // 	message: "接单成功！",
            // 	type: "success",
            // });
            // this.jdxzyjwcsj = false;
            // this.$router.push({
            // 	path: "gongdanxiangqing",
            // 	query: {
            // 		zhuangtai: 'N',
            // 		qianyiyemingcheng: '已接工单',
            // 		code: this.dangqiandanhao,
            // 		qianyiyemianglujing: "/home/kefuyijiegongdan"
            // 	}
            // });
            // this.dangqiandanhao = "";
          })
          .catch((err) => {
            this.isQueRenJieDan = false;
            if (err == "Error: Request failed with status code 401") {
              this.$router.push({
                path: "/login",
              });
            }
          });
      }
    },
    jiedanzhuataicx () {
      let data = {
        code: this.dangqiandanhao, //产品线
      };
      this.$request({
        method: "post",
        url: "Info/JieDanResult",
        data: data,
      })
        .then((res) => {
          console.log(res.Code);
          if (res.Code == "0" || res.Code == 0) {
            console.log(
              ".JOB_NUMBER",
              JSON.parse(localStorage.getItem("userInfo")).JOB_NUMBER
            );
            if (
              res.Data !== 0 &&
              res.Data !== null &&
              res.Data !== undefined &&
              res.Data ==
              JSON.parse(localStorage.getItem("userInfo")).JOB_NUMBER
            ) {
              this.$message({
                message: res.Msg,
                type: "success",
              });
              this.jdxzyjwcsj = false;
              this.$router.push({
                path: "gongdanxiangqing",
                query: {
                  zhuangtai: "N",
                  qianyiyemingcheng: "已接工单",
                  code: this.dangqiandanhao,
                  qianyiyemianglujing: "/home/kefuyijiegongdan",
                },
              });
              this.dangqiandanhao = "";
              this.$parent.ChaXun(1);
              this.ChaXun(1);
              clearInterval(this.timer); // 定时器名称
            } else {
              this.$message({
                message: "工单被别人接走了",
                type: "error",
              });
              this.jdxzyjwcsj = false;
              this.dangqiandanhao = "";
              this.$parent.ChaXun(1);
              this.ChaXun(1);
              clearInterval(this.timer); // 定时器名称
            }
          } else if (res.Code == "5" || res.Code == 5) {
            if (this.jixuqingqiu == true) {
              this.jiedanzhuataicx();
            } else {
              this.$message({
                message: "请求超时请重试",
                type: "success",
              });
              clearInterval(this.timer); // 定时器名称
            }
          } else {
            this.$message({
              message: res.Msg,
              type: "success",
            });
            this.ChaXun(this.currPage, this.dqcxzt);
            clearInterval(this.timer); // 定时器名称
          }
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 401") {
            this.$router.push({
              path: "/login",
            });
          }
        });
    },

    /**查看 */
    viewDoc (row) {
      console.log("this.SCXZ", row);
      this.SCXZ = row.$index + 1;
      let vmEl = this.$refs["tableData"].$el;
      const scrollParent = vmEl.querySelector(".el-table__body-wrapper");
      this.Nowscroll = scrollParent.scrollTop;
      console.log("this.Nowscroll", this.Nowscroll);
      this.$router.push({
        path: "gongdanxiangqing",
        query: {
          zhuangtai: "G",
          qianyiyemingcheng: "未接工单",
          code: row.row.CODE,
          qianyiyemianglujing: "/home/weijiekongdan",
        },
      });
    },

    getPath () {
      this.$router.push({
        path: "/login",
      });
    },

    addDate () {
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };
      console.log(date);

      if (date.month > 0 && date.month < 10) {
        date.month = "0" + date.month; //补齐
      }
      if (date.date > 0 && date.date < 10) {
        date.date = "0" + date.date; //补齐
      }
      nowDate.setMonth(nowDate.getMonth() - 1);
      var thirtyYear = nowDate.getFullYear();
      var thirtyMonth = nowDate.getMonth() + 1;
      var thirtyDay = nowDate.getDate();
      if (thirtyMonth >= 1 && thirtyMonth <= 9) {
        thirtyMonth = "0" + thirtyMonth;
      }
      if (thirtyDay >= 1 && thirtyDay <= 9) {
        thirtyDay = "0" + thirtyDay;
      }
      var monthDate = thirtyYear + "-" + thirtyMonth + "-" + "01";
      console.log(date.date, monthDate);
      // let shijianshuzu = [];
      let shijian = date.year + "-" + date.month + "-" + date.date;

      // shijianshuzu.push(shijian);
      // shijianshuzu.push(shijian);
      this.kaishishijian = monthDate;
      this.jieshushijian = shijian;
      if (
        window.localStorage.getItem("wjstartDate") != "null" &&
        window.localStorage.getItem("wjstartDate") != ""
      ) {
        this.kaishishijian = window.localStorage.getItem("wjstartDate");
        this.jieshushijian = window.localStorage.getItem("wjendDate");
      }
      this.yujiwanchengshijian = shijian + " 23:59:59";
    },

    /**分页size改变 */
    hanSiChange (val) {
      this.pageSize = val;
      this.currPage = 1;
      this.ChaXun(this.currPage, this.dqcxzt);
    },
    /**当前页改变 */
    hanCurrChange (val) {
      this.currPage = val;
      this.ChaXun(this.currPage, this.dqcxzt);
    },
    /**刷新表格数据 */
    handleRefresh () {
      this.currPage = 1;
      this.ChaXun(this.currPage, this.dqcxzt);
    },
    /**分页size改变 */
    hanSiChangekf (val) {
      this.pageSizekf = val;
      this.currPagekf = 1;
      this.Nowscroll = 0;
      this.SCXZ = "";
      this.getKefumingdan(1);
    },
    /**当前页改变 */
    hanCurrChangekf (val) {
      this.currPagekf = val;
      this.Nowscroll = 0;
      this.SCXZ = "";
      this.getKefumingdan(this.currPagekf);
    },
    /**刷新表格数据 */
    handleRefreshkf () {
      this.currPagekf = 1;
      this.getKefumingdan(this.currPagekf);
    },
  },
};
</script>

<style scoped>
.weijiekongdan {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 20px; */
  /* padding-left: 10px; */
  background-color: #f0f0f0;
}

.el-main {
  background-color: #f0f0f0;
  padding: 0px;
}

/* 头部选择模板名称 */
.header {
  height: auto;
  background-color: #ffffff;
  padding-left: 20px;
  padding-top: 20px;
  /* width: calc(100%-10px); */
}

.headerTop {
  display: flex;
  justify-content: space-between;
}

.header-con {
  height: auto;
  /* width: calc(100%-200px); */
  display: flex;
  align-items: center;
}

.header-con-form {
  display: flex;
  align-items: center;
}

.header-con-form-item {
  margin-bottom: 10px;
}

.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* 主体容器 */
.main {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 10px;
}

/* 主体容器 */
.maina {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

/**输入框宽度 */
.input {
  width: 200px;
}

/**dialog中样式 */
.dialog-con {
  height: 375px;
  overflow: auto;
}

/**底部分页 */
.footer {
  height: 50px;
  margin-right: 0px;
}

/**输入框宽度 */
.form-item-inputcpx {
  width: 160px;
}

.containera {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  margin-top: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.tijiaobtnxjgdza {
  /* display: flex; */
  margin-top: 30px;
  text-align: center;
  /* margin-left: 100px; */
  width: 50%;
  display: inline-block;
}

.tckmingcheng {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
}

.tckmingchenga {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.tijiaobtnxjgda {
  /* display: flex; */
  margin-top: 0px;
  margin-left: 40%;
  margin-bottom: 20px;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.tijiaobtnxjgdb {
  /* display: flex; */
  margin-top: 0px;
  margin-bottom: 20px;
  margin-right: 20%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.el-card {
  box-shadow: 0 1px 1px #f5f5f5 !important;
}

/deep/.eloption .el-select-dropdown__wrap {
  max-height: 400px !important;
}

/deep/ .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.el-table {
  overflow-y: auto !important;
  overflow-x: auto !important;
}

.headerzhuandanyuanyin {
  margin-top: 1%;
  margin-bottom: 1%;
  margin-left: 5%;
  width: 90%;
  font-size: 16px;
  color: #666666;
}
.sousuomingcheng {
  text-align: center;
  display: inline-block;
  margin-right: 10px;
  margin-left: 20px;
  font-size: 15px;
  font-weight: 400;
}
.anniuclass {
  margin-left: 20px;
  /* margin-top: 10px; */
  margin-bottom: 15px;
}
.weijiekongdan {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  /* padding: 20px; */
  padding-left: 0px;
  background-color: #f0f0f0;
}

.el-main {
  background-color: #f0f0f0;
  padding: 0px;
}

/* 头部选择模板名称 */
.header {
  height: auto;
  background-color: #ffffff;
  padding-left: 20px;
  padding-top: 20px;
  /* width: calc(100%-10px); */
}

.headerTop {
  display: flex;
  justify-content: space-between;
}

.header-con {
  height: auto;
  /* width: calc(100%-200px); */
  display: flex;
  align-items: center;
}

.header-con-form {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  word-wrap: break-word;
  overflow: hidden;
  margin: auto;
  /* 看自己需要设置，不影响div高度变化*/
}

.header-con-form-item {
  margin-bottom: 15px;
}

.list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  height: 100%;
}

.item {
  width: 100%;
  height: 100%;
}

.itema {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  height: 30px;
}

.itemb {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 0px;
  bottom: 0px;
}

.itemaBoxa {
  float: left;
  margin-top: 3px;
  margin-left: 0px;
  margin-left: 4px;
  width: 100px;
  height: 30px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxb {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 200px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemaBoxc {
  float: left;
  margin-top: 0px;
  margin-left: 20px;
  width: 100px;
  height: 20%;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 25px;
  color: #000000;
  opacity: 1;
}

.itemBox {
  box-sizing: border-box;
  width: 100%;
  border: 1px solid #ebeef5;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
  height: 80px;
}

.itemBoxa {
  float: left;
  top: 20px;
  left: 0px;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxb {
  float: left;
  top: 20px;
  left: 20%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxc {
  float: left;
  top: 20px;
  left: 40%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.itemBoxd {
  float: left;
  top: 20px;
  left: 60%;
  margin-left: 4px;
  width: 20%;
  height: 20%;
}

.anniuclass {
  margin-left: 20px;
  /* margin-top: 10px; */
  margin-bottom: 15px;
}

.itemTop {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 80px;
  padding: 0 25px;
  /* border-bottom: 1px solid #F2F4F9; */
}

.itemTopText {
  float: left;
  width: 80px;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 25px;
  color: #000000;
  opacity: 1;
  margin-left: 10rpx;
}

.sousuoyou {
  float: right;
  margin-top: 20px;
  /* right: 30px; */
  margin-right: 20px;
  width: 92px;
  height: 36px;
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  /* width: 100%;
	height: 100%; */
  overflow: hidden;
  /* background-color: #fff; */
}

.container {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

/* 主体容器 */
.main {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

/* 主体容器 */
.maina {
  margin-top: 10px;
  height: 590px;
  overflow-y: auto;
  margin-right: 0px;
}

.yemakuandu {
  width: 99%;
  background-color: #fff;
  height: 40px;
  padding-top: 20px;
}

/**输入框宽度 */
.input {
  width: 200px;
}

/**dialog中样式 */
.dialog-con {
  height: 375px;
  overflow: auto;
}

.itemc {
  margin-top: 10px;
  box-sizing: border-box;
  width: 100%;
  margin-bottom: 10px;
  /* height: 98%; */
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemcBoxa {
  width: 49.95%;
  height: 70px;
  max-height: 100px;
  float: none;

  background-color: #fff;
}

.itemd {
  box-sizing: border-box;
  width: 100%;
  height: 98%;
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
}

.itemdtext {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 80%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

.itemdtexta {
  margin-left: 10px;
  margin-top: 20px;
  margin-bottom: 10px;
  width: 16%;
  height: 22px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  line-height: 22px;
  color: #181818;
  opacity: 1;
  text-decoration: underline;
}

/**底部分页 */
.footer {
  height: 50px;
  margin-right: 0px;
}

/**输入框宽度 */
.form-item-inputcpx {
  width: 200px;
}

.containera {
  width: 100%;
  height: 100%;
  padding-left: 10px;
  margin-top: -10px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.headerxjgd {
  margin-top: 10px;
  margin-bottom: 15px;
  padding-left: 20px;
}

.headeraxjgd {
  margin-bottom: 2px;
}

.fanhuiBtnxjgd {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 20px;
  display: inline-block;
}

.yonghuminglabexjgd {
  margin-top: 0px;
  margin-left: 90px;
  margin-bottom: 20px;
  display: inline-block;
}

/* 主体容器 */
.mainxjgd {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

/* 主体容器 */
.mainxjgda {
  height: 100%;
  /* overflow: hidden; */
  background-color: #fff;
  padding: 0px;
  margin-top: 20px;
  box-sizing: border-box;
}

.tijiaobtnxjgd {
  /* display: flex; */
  margin-top: 30px;
  margin-left: 50%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
}

.tijiaobtnxjgdza {
  /* display: flex; */
  margin-top: 30px;
  text-align: center;
  /* margin-left: 100px; */
  width: 50%;
  display: inline-block;
}

.tckmingcheng {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
}

.tckmingchenga {
  width: 100%;
  margin-left: 10px;
  text-align: center;
  font-size: 16px;
  color: #333333;
  margin-top: 30px;
}

.tijiaobtnxjgda {
  /* display: flex; */
  margin-top: 0px;
  margin-left: 40%;
  margin-bottom: 20px;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.tijiaobtnxjgdb {
  /* display: flex; */
  margin-top: 0px;
  margin-bottom: 20px;
  margin-right: 20%;
  text-align: center;
  /* margin-left: 100px; */
  width: 100px;
  display: inline-block;
}

.header-conxjgd {
  margin-left: 0px;
}

.header-conaxjgd {
  display: flex;
  align-items: center;
  height: 30px;
  margin-left: 30px;
}

.header-con-formxjgd {
  display: flex;
  align-items: center;
}

.sousuomingcheng {
  text-align: center;
  display: inline-block;
  margin-right: 10px;
  margin-left: 20px;
  font-size: 15px;
  font-weight: 400;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatarxjgd {
  width: 178px;
  height: 178px;
  display: block;
}

.el-card {
  box-shadow: 0 1px 1px #f5f5f5 !important;
}

/deep/.eloption .el-select-dropdown__wrap {
  max-height: 400px !important;
}

/deep/ .el-select__tags {
  flex-wrap: nowrap;
  overflow: hidden;
}

.el-table {
  overflow-y: auto !important;
  overflow-x: auto !important;
}
</style>
